<template>
  <div class="wrap_businessIntroduction wow fadeInUp">
    <el-row v-for="(itm,inx) in serviceArray" :key="inx">
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block">
      <div
        
        class="header_block server_box"
        v-for="(item,index) in itm"
        :key="index"
      >
        <img :src="item.url" class="server_img" />
        <p class="server_title">{{item.title}}</p>
        <div class="wrap_ps">
        <p class="server_titleEng" v-for="(itmm,inmm) in item.titleEng" :key="inmm">{{itmm}}</p>
        </div>
      </div>
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "businessIntroduction",
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  data() {
    return {
      serviceArray: [
        [{
          url: require("@/assets/imgs/team1.png"),
          title: "策略策划团队",
          titleEng: ["策略总监","客户经理","项目统筹"]
        },
        {
          url: require("@/assets/imgs/team2.png"),
          title: "运营团队",
          titleEng: ["店铺运营","视觉设计","内容策划","商品运营","项目经理","策略执行"]
        },
        {
          url: require("@/assets/imgs/team3.png"),
          title: "直播执行团队",
          titleEng: ["直播技术总监","直播导演","直播场控","直播运营","专业主播"]
        },
        {
          url: require("@/assets/imgs/team4.png"),
          title: "短视频团队",
          titleEng: ["编导","内容运营","后期剪辑","后期包装","粉丝运营"]
        },
        {
          url: require("@/assets/imgs/team5.png"),
          title: "投放团队",
          titleEng: ["广告投放经理","数据优化师"]
        },
        {
          url: require("@/assets/imgs/team6.png"),
          title: "数据团队",
          titleEng: ["数据研究","数据运营","大盘分析"]
        }],
        // [{
        //   url: require("@/assets/imgs/team6.png"),
        //   title: "粉丝增长",
        //   titleEng: "运营、互动、采购，组合拳助力粉丝增长。"
        // },
        // {
        //   url: require("@/assets/imgs/a7.png"),
        //   title: "其他方式",
        //   titleEng: "直播造势，引爆舆论热点。 "
        // },
        // {
        //   url: require("@/assets/imgs/a8.png"),
        //   title: "评论互动",
        //   titleEng: "评论收集、评论回复、互动"
        // },
        // {
        //   url: require("@/assets/imgs/a9.png"),
        //   title: "用户维护 ",
        //   titleEng: "维护用户，帮助涨粉"
        // },
        // {
        //   url: require("@/assets/imgs/a10.png"),
        //   title: "运营分析 ",
        //   titleEng: "每月提供专业运营报告，及时提供数据反馈，做出运营调整。"
        // }
        // ]
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_businessIntroduction {
  .header_block {
    min-height: 10px;
  }
  .server_box {
    width: calc(100% / 6);
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
    .server_img {
      // width: 45%;
      // width: 62px;
      height: 62px;
    }
    .server_title {
      font-size: 20px;
    color: #676767;
    line-height: 50px;
    }
    .wrap_ps{
      width: 120px;
    height: 224px;
    /* border: 1px solid #888; */
    box-sizing: border-box;
    // padding: 10px;
    box-shadow: 0 28px 46px 0 rgba(0, 0, 0, 0.12);
    }
    .server_titleEng {
      font-size: 14px;
    color: #676767;
    line-height: 24px;
    padding: 5px 0px;
      text-align: center;
      // color: #e91d62;
    }
  }
}
</style>



